import ReactDOM from 'react-dom';
import App from 'App';
import { Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryParamProvider } from 'use-query-params';
import { store } from 'components/store/index';
import { history } from 'Utils';
import { ScrollTop } from 'Elements';

const appRoot = document.getElementById('root');
const appJsx = (
	<Provider store={store}>
		<Router history={history}>
			<QueryParamProvider ReactRouterRoute={Route}>
				<ScrollTop>
					<App />
				</ScrollTop>
			</QueryParamProvider>
		</Router>
	</Provider>
);
ReactDOM.render(appJsx, appRoot);
